var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.39 86.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.maestro-d {\n\t\t\t\tfill: #00a1df\n\t\t\t}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maestro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 131.39 V 86.9 H 0 Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.585873,13.528624 48.486586,3.046418 -1.73166,52.1155 -46.754924,6.636838 z",
    style: {
      fill: "#7673c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.94,43.45a35.94,35.94,0,0,1,13.75-28.3,36,36,0,1,0,0,56.61A35.94,35.94,0,0,1,51.94,43.45Z",
    style: {
      fill: "#eb001b"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "maestro-d",
    d: "M120.5,65.76V64.6H121v-.24h-1.19v.24h.47v1.16Zm2.31,0v-1.4h-.36l-.42,1-.42-1h-.36v1.4h.26V64.7l.39.91h.27l.39-.91v1.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "maestro-d",
    d: "M123.94,43.45a36,36,0,0,1-58.25,28.3,36,36,0,0,0,0-56.61,36,36,0,0,1,58.25,28.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaestro);
export default __webpack_public_path__ + "static/media/icon-maestro.ccc0e96ff085c6ff4942ab22aa0898b2.svg";
export { ForwardRef as ReactComponent };